export enum Status {
    Active = "Active",
    Deleted = "Deleted",
    Pending = "Pending"
}